// Auto generated file, do not manually modify!
// com.hotpads.usermanagement.api.web.user.company.UmcCompanyOverviewWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CompanyUserActivePropertyCountsDto,
  GetActivePropertyDetailsForCompanyUserResponseDto,
  ListingAlias,
  PublicRenameCompanyRequestDto,
  UmcGetActiveProfilesRequestDto,
  UmcGetPendingProfilesRequestDto,
  UserCompanyPropertiesPageDto,
  UserCompanyStatsDto,
  UserManagementCompanyProfilesDto,
  UserManagementCreateUpdateCompanyResponseDto,
  UserManagementInvitationDto,
  UserManagementInviteUserRequestDto,
  Zuid,
} from '../..';

interface GetUserActiveCompanyPropertiesParams {
  startAlias?: ListingAlias;
  zuid: Zuid;
}
interface GetUserCompanyActivePropertyCountParams {
  zuid: Zuid;
}
interface GetUserCompanyPropertiesParams {
  zuid: Zuid;
}
interface ResendInviteEmailParams {
  email: string;
}
interface VerifyEmailParams {
  email: string;
}

export const UmcCompanyOverviewWebApiHandler_createUserInvitation_Path =
  '/api/web/companyOverview/createUserInvitation';

/**
 * Create a new pending user and send invitation
 */
export const UmcCompanyOverviewWebApiHandler_createUserInvitation = (
  postData: UserManagementInviteUserRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserManagementInviteUserRequestDto, void>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_createUserInvitation_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_declineUserManagementInvitation_Path =
  '/api/web/companyOverview/declineUserManagementInvitation';

/**
 * Decline invitation to user management
 */
export const UmcCompanyOverviewWebApiHandler_declineUserManagementInvitation = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_declineUserManagementInvitation_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserActiveCompanyProperties_Path =
  '/api/web/companyOverview/getUserActiveCompanyProperties';

/**
 * Get a user's company properties
 */
export const UmcCompanyOverviewWebApiHandler_getUserActiveCompanyProperties = (
  getParams: GetUserActiveCompanyPropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUserActiveCompanyPropertiesParams, never, UserCompanyPropertiesPageDto>(
    {
      getParams: getParams,
      endpoint: UmcCompanyOverviewWebApiHandler_getUserActiveCompanyProperties_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserCompanyActivePropertyCount_Path =
  '/api/web/companyOverview/getUserCompanyActivePropertyCount';

/**
 * Get a user's active property count
 */
export const UmcCompanyOverviewWebApiHandler_getUserCompanyActivePropertyCount = (
  getParams: GetUserCompanyActivePropertyCountParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUserCompanyActivePropertyCountParams, never, CompanyUserActivePropertyCountsDto>(
    {
      getParams: getParams,
      endpoint: UmcCompanyOverviewWebApiHandler_getUserCompanyActivePropertyCount_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserCompanyProperties_Path =
  '/api/web/companyOverview/getUserCompanyProperties';

/**
 * Get a user's company properties
 */
export const UmcCompanyOverviewWebApiHandler_getUserCompanyProperties = (
  getParams: GetUserCompanyPropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUserCompanyPropertiesParams, never, GetActivePropertyDetailsForCompanyUserResponseDto>(
    {
      getParams: getParams,
      endpoint: UmcCompanyOverviewWebApiHandler_getUserCompanyProperties_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserCompanyStats_Path = '/api/web/companyOverview/getUserCompanyStats';

export const UmcCompanyOverviewWebApiHandler_getUserCompanyStats = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserCompanyStatsDto>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_getUserCompanyStats_Path,
      method: 'POST',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserManagementActiveProfiles_Path =
  '/api/web/companyOverview/getUserManagementActiveProfiles';

export const UmcCompanyOverviewWebApiHandler_getUserManagementActiveProfiles = (
  postData: UmcGetActiveProfilesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UmcGetActiveProfilesRequestDto, UserManagementCompanyProfilesDto>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_getUserManagementActiveProfiles_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserManagementInvitation_Path =
  '/api/web/companyOverview/getUserManagementInvitation';

/**
 * Get invitation details
 */
export const UmcCompanyOverviewWebApiHandler_getUserManagementInvitation = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserManagementInvitationDto>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_getUserManagementInvitation_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_getUserManagementPendingProfiles_Path =
  '/api/web/companyOverview/getUserManagementPendingProfiles';

export const UmcCompanyOverviewWebApiHandler_getUserManagementPendingProfiles = (
  postData: UmcGetPendingProfilesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UmcGetPendingProfilesRequestDto, UserManagementCompanyProfilesDto>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_getUserManagementPendingProfiles_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_renameCompany_Path = '/api/web/companyOverview/renameCompany';

/**
 * Rename the current user's company
 */
export const UmcCompanyOverviewWebApiHandler_renameCompany = (
  postData: PublicRenameCompanyRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, PublicRenameCompanyRequestDto, UserManagementCreateUpdateCompanyResponseDto>(
    {
      endpoint: UmcCompanyOverviewWebApiHandler_renameCompany_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_resendInviteEmail_Path = '/api/web/companyOverview/resendInviteEmail';

export const UmcCompanyOverviewWebApiHandler_resendInviteEmail = (
  getParams: ResendInviteEmailParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ResendInviteEmailParams, never, void>(
    {
      getParams: getParams,
      endpoint: UmcCompanyOverviewWebApiHandler_resendInviteEmail_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcCompanyOverviewWebApiHandler_verifyEmail_Path = '/api/web/companyOverview/verifyEmail';

/**
 * Verify if an email can be added to a company
 */
export const UmcCompanyOverviewWebApiHandler_verifyEmail = (getParams: VerifyEmailParams, client = getClient()) => {
  return httpFrontEndRequest<VerifyEmailParams, never, void>(
    {
      getParams: getParams,
      endpoint: UmcCompanyOverviewWebApiHandler_verifyEmail_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};
